import * as React from 'react';
import LogCell from './logCell';
import Date from '../getDate';

const LogGroup = ({ data }) => (
    <div className="logListingGroup detailListingGroup">
        <div className="date"><Date inputDate={data} /></div>
        {data.data.map((d) => {
            return <React.Fragment key={d.id}><LogCell data={d.data} /></React.Fragment>
        })}
    </div>
);

export default LogGroup;
